<template>
	<div class="head-info">
		恭喜
		<span>{{ name }}</span>
		，您的报名信息已提交，请谨记您的报名序号，并确保已上传本人照片。
		<span>报名序号：{{ serial_id }}</span>
	</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
	computed: {
		...mapState({
			name: state => state.user.examinee.name,
			serial_id: state => state.user.examinee.serial_id,
			verify: state => state.user.examinee.verify,
			is_pay: state => state.user.examinee.is_pay,
		})
	}
};
</script>

<style lang="scss" scoped>
.head-info {
	line-height: 86px;
	text-align: center;
	width: 100%;
	height: 86px;
	background: #ffe9e9;
	box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.16);
	color: #ff070a;
	border-radius: 5px 5px 0 0;
	> span {
		color: #07901f;
	}
}
</style>
